/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */
export const sessionKeys = {
	/**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */
	FOLDER_VIEW_LAYOUT: 'folder.view.layout',

	/**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */
	TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',

	/**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */
	ENABLE_LOGGING: 'confluence.enable-logging',

	/**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */
	LOG_LEVEL: 'confluence.log-level',

	/**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */
	PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',

	/**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */
	NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',

	/**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */
	EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
};
